export default "/images/stuhmer-logo.png?df5fda7e95d0eda4dc642f233fb9b3bb";